import { tv } from '~/utils/tv'

export const inputCounterHelperTextContainerVariants = tv({
  base: `flex flex-row justify-star w-[100%] items-center px-onepulse
         `,
  variants: {},
})

export const inputCounterHelperTextMessageVariants = tv({
  base: `
         flex text-left font-rdmodern font-semibold text-text-neutral-alternative text-threepulse
         line-clamp-2
  `,
  variants: {
    hasError: {
      true: 'text-text-danger-alternative',
      false: '',
    },
    readOnly: {
      true: 'cursor-not-allowed',
    },
    disabled: {
      true: 'cursor-not-allowed text-text-neutral-disabled',
      false: '',
    },
  },
  compoundVariants: [
    {
      readOnly: true,
      disabled: false,
      class: 'text-text-neutral-readonly',
    },
  ],
  defaultVariants: {
    hasError: false,
    disabled: false,
    readOnly: false,
  },
})
